"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalContent = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const ScrollableContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '60vh'
  }
}));
const StyledModalContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  rowGap: theme.spacing(3),
  marginTop: theme.spacing(3),
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    maxHeight: '60vh'
  },
  [theme.breakpoints.down('xl')]: {
    paddingRight: theme.spacing(2)
  }
}));
const ModalContent = ({
  dataId,
  children
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollableContent, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledModalContent, {
      ...getTestIdProps(`${dataId ?? 'modal-container'}`),
      children: children
    })
  });
};
exports.ModalContent = ModalContent;
